export async function convertSvgToPng(svgString) {
  return new Promise((resolve, reject) => {
    let canvas = document.createElement("canvas");
    canvas.width = 800;
    canvas.height = 350;
    let ctx = canvas.getContext("2d");

    let img = new Image();

    img.onload = function () {
      ctx.drawImage(img, 0, 0);
      let png = canvas.toDataURL("image/jpg");
      resolve(png);
    };

    img.onerror = function () {
      reject();
    };
    img.src = 'data:image/svg+xml;charset-utf-8,' + encodeURIComponent(svgString);
  });
}



// WEBPACK FOOTER //
// ./src/scripts/services/svgToPngImageConvert.js